import { render, staticRenderFns } from "./home-mcn.vue?vue&type=template&id=e4927c26&scoped=true"
import script from "./home-mcn.vue?vue&type=script&lang=js"
export * from "./home-mcn.vue?vue&type=script&lang=js"
import style0 from "./home-mcn.vue?vue&type=style&index=0&id=e4927c26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4927c26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4927c26')) {
      api.createRecord('e4927c26', component.options)
    } else {
      api.reload('e4927c26', component.options)
    }
    module.hot.accept("./home-mcn.vue?vue&type=template&id=e4927c26&scoped=true", function () {
      api.rerender('e4927c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/home-mcn.vue"
export default component.exports